module.exports = __webpack_public_path__ + "static/media/fottur.d0f65a72.jpg";